import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "@tsp-core/store/utils";

import { ContractTypeId, ContractTypesDictionary } from "../types";

type GetContractTypesResponseData = {
  items: Array<{
    id: ContractTypeId;
    name: string;
  }>;
};

export const contractTypesApi = createApi({
  reducerPath: "@contract-types/api",
  baseQuery,
  refetchOnFocus: false,
  refetchOnReconnect: false,
  refetchOnMountOrArgChange: false,
  keepUnusedDataFor: 60 * 60 * 24,
  endpoints: (builder) => ({
    getContractTypesDictionary: builder.query<ContractTypesDictionary, void>({
      query: () => ({
        url: "/contractTypes",
        method: "POST",
      }),
      transformResponse: (response: GetContractTypesResponseData) => {
        return response.items.reduce((accumulator, item) => {
          accumulator[item.id] = {
            id: item.id,
            name: item.name,
          };
          return accumulator;
        }, {} as ContractTypesDictionary);
      },
    }),
  }),
});
